import ApiHelpMain from "/src/components/ApiHelpMain"

function ApiHelp() {
  return (
    <>
      <div id="api-help-wrapper">
       <ApiHelpMain />
      </div>
    </>
  )
}
export default ApiHelp;